import { render } from "./AddAssessor.vue?vue&type=template&id=115a5bfe&ts=true"
import script from "./AddAssessor.vue?vue&type=script&lang=ts"
export * from "./AddAssessor.vue?vue&type=script&lang=ts"

import "./AddAssessor.vue?vue&type=style&index=0&id=115a5bfe&lang=css"
import "./AddAssessor.vue?vue&type=style&index=1&id=115a5bfe&lang=css"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__